export const jobOpenings = [
  {
    id: 1,
    title: 'Sales & Marketing Executives',
    locations: ['Bengaluru', 'Coimbatore', 'Ahmedabad', 'Gurugram'],
    requirements: [
      'Minimum 1-3 years of experience in Fasteners or relevant industry will be preferable.',
      'Knowledge of industrial area & dealers market is a must.',
      'If the applicant is a native of the relevant city, that is preferable & one must know the state language.',
      'Communication and negotiation skills are a must.',
      'Must be able to work in deadlines and strong follow-up is required.'
    ],
    contactEmail: 'hr@xpsindia.com'
  }
]; 